// ScrollToTop.jsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top of the page when path changes
    window.scrollTo({ top: 0, behavior: 'instant' }); // or 'smooth'
  }, [pathname]);

  return null;
}
